import { css, unsafeCSS, html, nothing } from 'lit';
import SotbitAccordion from '../default';
import styles from './accordionDraggable.scss?inline';
import { ref } from 'lit/directives/ref.js';

export default class SotbitAccordionDraggable extends SotbitAccordion {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    toggleOpen() {
        this.open = !this.open;
    }

    stopPropagation(e) {
        e.stopPropagation();
    }

    render() {
        return html`
            <div class="collapse">
                <div class="collapse-header">
                    <div class="icon-wrapper" @click="${this.toggleOpen}" @mousedown=${this.stopPropagation}>
                        <sotbit-icon
                            class="toggle-arrow"
                            pointer
                            variant="secondary"
                            size="m"
                            icon="arrow-down"
                            rotate="${this.open ? '180' : nothing}"
                        >
                        </sotbit-icon>
                    </div>

                    <div class="header-content">
                        <slot name="header"></slot>
                    </div>

                    <div class="header-icons" @mousedown=${this.stopPropagation}>
                        <slot name="actions"></slot>
                    </div>
                </div>
                <div class="collapse-body" @mousedown=${this.stopPropagation} ${ref(this._collapseBody)}}>
                    <div class="collapse-body-inner">
                        <slot></slot>
                    </div>
                </div>
            </div>
        `;
    }
}
